import { mediaQuery, mediaQueryMax } from 'components';
import styled from 'styled-components';

export const GridItem = styled.div`
  [class*='Badge'] {
    pointer-events: none;
  }
`;

export const GridWrapper = styled.div<{
  fourColumnGrid: boolean;
  isTwoUpMobile: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: '.';
  grid-gap: 1rem;
  padding: 0;

  ${mediaQuery.medium`
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: ". . .";
  `};

  ${({ fourColumnGrid }) =>
    fourColumnGrid &&
    mediaQuery.medium`
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas: ". . . .";
  `};

  ${({ isTwoUpMobile }) =>
    isTwoUpMobile &&
    mediaQueryMax.medium`
    grid-template-columns: 1fr 1fr;
    grid-template-areas: ". .";
  `};
`;

export const EnvelopeSvgWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const NoResultsWrapper = styled.div`
  text-align: center;
`;

export const LimitedResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const ClearFiltersButton = styled.button`
  margin-left: auto;
  border-radius: 5px;
  color: #757575;
  cursor: pointer;
  letter-spacing: 3px;
  background-color: white;
  border: 0;
`;
